export default __webpack_public_path__ + "static/media/jop_logo@2x.c4d17747.png";